import get from 'lodash/get';
import { getArcadeCabinetList } from 'arcade/sections/cabinets/selectors';

// arcade rooms
export const getArcadeRooms = state => get(state, 'arcade.rooms', {});
export const getArcadeRoomsRooms = state => get(getArcadeRooms(state), 'rooms', []);

export const getRoom = state => get(getArcadeRooms(state), 'room', {});
export const getRoomId = state => get(getRoom(state), 'id', undefined);
export const getRoomCabinets = state => get(getRoom(state), 'cabinets', []);
export const hasCabinets = state => !!getRoomCabinets(state).length;
export const mapCabinetIds = state => getRoomCabinets(state).map(cabinet => cabinet.cabinetId);

// orderable cabinets
export const getCabinetOptions = state => {
    const cabinetOptions = getArcadeCabinetList(state);
    const cabinets = getRoomCabinets(state);
    return cabinetOptions.map(option => ({
        ...option,
        disabled: !!cabinets.some(cabinet => option.cabinetId === cabinet.cabinetId)
    }));
};
